import React, {useState} from 'react';
import _find from 'lodash/find';
import S from 'StyledAccountResponsibleGame.js';
import ResponsibleGamingForm from 'ResponsibleGamingForm.js';
import AccountResponsibleGameSelfExclusion from 'AccountResponsibleGameSelfExclusion.js';
import AccountSessionTimer from 'AccountSessionTimer.js';
import {translation} from 'helpers/utilsHelper.js';
import ResponsibleLimitsTable from 'ResponsibleLimitsTable.js'

const tabs = [
    { label: 'account_responsibleGame_responsibleGameTab', value: 1 },
    { label: 'account_responsibleGame_limitsTab', value: 2 },
  ]

const AccountResponsibleGame = () => {
    const [activeTab, setActiveTab] = useState(1);

    return (
        <S.AccountResponsibleGame>
            <S.AccountResponsibleGameTabs>
                <S.TabsWrapper>
                    {tabs.map(({ label, value }, index) => {
                        return (
                            <S.Tab key={index} className={`tab ${value === activeTab ? 'active-tab' : ''}`} onClick={() => setActiveTab(value)}>{translation(label)}</S.Tab>
                        )
                    })}
                </S.TabsWrapper>
            </S.AccountResponsibleGameTabs>

            {
            
            activeTab === 1 ? 
                <AccountResponsibleGameSelfExclusion/>
            :
            activeTab === 2 ? 
                <>
                    <ResponsibleLimitsTable/>
                    <ResponsibleGamingForm modal={false}/> 
                </>
            : null
            
            }

            <AccountSessionTimer/>

        </S.AccountResponsibleGame>
    );
}

export default AccountResponsibleGame;